import {operatorNames} from "components/Homeowner/Dashboard/QuickListConfigOperatorNames";

export const simpleDaysDropdown = [
  {value: "-30,0", label: "Last 30", operator: operatorNames.Range},
  {value: "-7,0", label: "Last 7", operator: operatorNames.Range},
  {value: " ", label: "Today", operator: operatorNames.Today}, //needs a non falsey value (" " instead of "") so it renders its label in the dropdown
];
export const simpleDaysDropdown2 = [
  ...simpleDaysDropdown,
  {value: "0,7", label: "Next 7", operator: operatorNames.Range},
  {value: "0,30", label: "Next 30", operator: operatorNames.Range},
];

export const simpleTimeDropdown = [
  {value: "1", label: "0", operator: operatorNames.LessThan},
  {value: "2", label: "1", operator: operatorNames.LessThan},
  {value: "3", label: "2", operator: operatorNames.LessThan},
  {value: "2.99", label: "3 or more", operator: operatorNames.GreaterThan},
];

export const simpleTimeDropdown2 = [
  {value: "0,5.99", label: "0 to <6 Days", operator: operatorNames.Range},
  {value: "6,10.99,", label: "6 to <11", operator: operatorNames.Range},
  {value: "11,20.99", label: "11 to <21", operator: operatorNames.Range},
  {value: "21,30.99", label: "21 to <31", operator: operatorNames.Range},
  {value: "30.99", label: "31 or more days", operator: operatorNames.GreaterThan},
];

export const yesNo = [
  {value: "yes", label: "Yes"},
  {value: "no", label: "No"},
];

export const appraisalStatus = [
  {value: "all open", label: "All Open"},
  {value: "appraiser reconsidering", label: "Appraiser Reconsidering"},
  {value: "appraiser working on veros preview errors", label: "Appraiser Working on Veros Preview Errors"},
  {value: "assigned", label: "Assigned"},
  {value: "assigned to qa manager", label: "Assigned to QA Manager"},
  {value: "available to appraiser", label: "Available To Appraiser"},
  {value: "awaiting eligibility decision", label: "Awaiting Eligibility Decision"},
  {value: "awaiting field report", label: "Awaiting Field Report"},
  {value: "cancelled", label: "Cancelled"},
  {value: "closed", label: "Closed"},
  {value: "completed", label: "Completed"},
  {value: "customer rejection", label: "Customer Rejection"},
  {value: "field reconsidering", label: "Field Reconsidering"},
  {value: "gaar preview error appraiser", label: "GAAR Preview Error Appraiser"},
  {value: "in appraisal qa", label: "In Appraisal QA"},
  {value: "in review", label: "In Review"},
  {value: "internal rejection", label: "Internal Rejection"},
  {value: "pending appraisal assignment", label: "Pending Appraisal Assignment"},
  {value: "pending appraisal qa", label: "Pending Appraisal QA"},
  {value: "rejected to appraiser", label: "Rejected to Appraiser"},
  {value: "rejected to field", label: "Rejected to Field"},
  {value: "unassigned", label: "Unassigned"},
  {value: "order payment pending", label: "Order Payment Pending"},
  {value: "order payment required", label: "Order Payment Required"},
  {value: "order payment expired", label: "Order Payment Expired"},
];

export const testAndTrainingAccounts = [
  {value: "1194", label: "Miller Industries Towing Equipment Inc"},
  {value: "666", label: "STEVE WRIGHT DEMO CUSTOMER"},
  {value: "3", label: "Demo Account"},
  {value: "333", label: "Cases Sent To Street-Not To Mail"},
  {value: "5679", label: "IT Testing Customer"},
  {value: "589", label: "Training 1 (Mueller RCT)"},
  {value: "590", label: "Training 2 (Mueller ISO)"},
  {value: "592", label: "Training 4 (Allstate)"},
  {value: "594", label: "Training 5 (OneBeacon)"},
  {value: "603", label: "Training 6 (Liberty/Xactvalue)"},
  {value: "1021", label: "Training 7 (Wind Mitigation)"},
  {value: "866", label: "Mueller Quality Audit"},
  {value: "1067", label: "Allstate Audit"},
  {value: "1319", label: "Mueller Appraisal"},
  {value: "5678", label: "Jason Kostempski"},
  {value: "1", label: "Mueller Services Inc"},
  {value: "1035", label: "Mueller Citizens Field Verifications"},
];

export const webStatus = [
  {value: "received", label: "Received"},
  {value: "unassigned", label: "Unassigned"},
  {value: "qa", label: "QA"},
  {value: "completionpending", label: "Completion Pending"},
  {value: "orderpaymentpending", label: "Order Payment Pending"},
  {value: "orderpaymentrequired", label: "Order Payment Required"},
  {value: "preassignment", label: "Preassignment"},
  {value: "cancelled", label: "Cancelled"},
  {value: "closed", label: "Closed"},
  {value: "completed", label: "Completed"},
  {value: "awaitingdata", label: "Awaiting Data"},
  {value: "datafailed", label: "Data Failed"},
];

export const hazards = [
  {value: "major", label: "Major"},
  {value: "minor", label: "Minor"},
];

export const businessTypes = [
  {value: "1", label: "New Business"},
  {value: "2", label: "Renewal"},
];

export const activeInactive = [
  {value: "active", label: "Active"},
  {value: "inactive", label: "Inactive"},
];

export const inspectionClass = [
  {value: "Exterior", label: "Exterior"},
  {value: "Interior", label: "Interior"},
  {value: "Specialty", label: "Specialty"},
  {value: "Other", label: "Other"},
];

export const customerTypeCode = [
  {value: "EXISTING_LENDER", label: "Lender Existing"},
  {value: "NEW_LENDER", label: "Lender New"},
  {value: "EXISTING_INSURANCE", label: "Insurance Existing"},
  {value: "NEW_INSURANCE", label: "Insurance New"},
  {value: "EXISTING_LOSS_DRAFT", label: "Loss Draft Existing"},
  {value: "NEW_LOSS_DRAFT", label: "Loss Draft New"},
];

// this is in Mueller.Business.Models.InspectorHiringForecastStatus.cs
export const inspectorHiringForecastStatus = [
  {value: "1", label: "Open"},
  {value: "2", label: "In Recruiting"},
  {value: "3", label: "Closed"},
];

export const feedbackCategories = [
  {value: "1", label: "Broker/Borrower about Appraiser"},
  {value: "2", label: "QA2 Completed about Appraiser"},
  {value: "3", label: "QA2 Returned about Appraiser"},
  {value: "4", label: "Appraiser about Field Rep"},
  {value: "5", label: "Appraiser about Ops Manager"},
  {value: "6", label: "Appraiser about Technology"},
  {value: "7", label: "Homeowner Overall Experience"},
  {value: "8", label: "Homeowner Inspection Preference"},
  {value: "9", label: "Homeowner Inspection Difficulty"},
  {value: "10", label: "Homeowner Inspection Duration"},
];

// this is also in Mueller.Business.Models InspectorSpecificCodes.cs
export const inspectorSpecificCodes = [
  {value: "988", label: "VALUATION SERVICES TEAM (988)"},
  {value: "995", label: "CALL CENTER NO COVERAGE (995)"},
  {value: "996", label: "CALL CENTER CALLS (996)"},
  {value: "999", label: "CUSTOMER SERVICE (999)"},
];

// These groups are defined in Mueller.Business.BusinessLogic.SearchResultProviders.FilterProvider AppraisalFilterProvider.cs
export const appraisalPortStatusGroups = [
  {value: "assigned", label: "Assigned to Provider"},
  {value: "cancelled", label: "Cancelled"},
  {value: "cancelledforupgrade", label: "Cancelled for Upgrade"},
  {value: "disputed", label: "Disputed"},
  {value: "onhold", label: "On Hold"},
  {value: "complete", label: "Complete"},
  {value: "accepted", label: "Accepted"},
  {value: "rejected", label: "Rejected"},
  {value: "allother", label: "All Other Statuses"},
];

export const feedbackResultsOptions = [
  {value: "agree", label: "Agree"},
  {value: "disagree", label: "Disagree"},
];

//
export const lowMediumHighTiers = [
  {value: "Low", label: "Low"},
  {value: "Medium", label: "Medium"},
  {value: "High", label: "High"},
];

// Mueller.Business.Models.CubiCasa.CubiCasaScanStatus
export const cubiCasaStatus = [
  {value: "Waiting", label: "Waiting"},
  {value: "Complete", label: "Complete"},
  {value: "Deleted", label: "Deleted"},
  {value: "Failed", label: "Failed"},
];

// See Mueller.Business.Models.QuickLists FilterTypes.cs
export const filterTypes = {
  hazardLevel: "HazardLevel",
  customerNumbers: "CustomerNumbers",
  date: "Date",
  yesNo: "YesNo",
  fieldStatus: "FieldStatus",
  states: "States",
  surveyTypes: "SurveyTypes",
  text: "Text",
  time: "Time",
  appraisalStatus: "AppraisalStatus",
  assignmentTypes: "AssignmentTypes",
  fieldLevelCoordinator: "FieldLevelCoordinator",
  fieldDirector: "FieldDirector",
  appraiserAssigned: "AppraiserAssigned",
  bool: "Bool",
  businessTypes: "BusinessTypes",
  underWriterActions: "UnderWriterActions",
  surveyClass: "SurveyClass",
  customerServiceAssignUsers: "CustomerServiceAssignUsers",
  underwriterCode: "UnderwriterCode",
  inspectorHiringForecastStatus: "InspectorHiringForecastStatus",
  appraisalSupportRepresentatives: "AppraisalSupportRepresentatives",
  countTen: "CountTen",
  qualityAssuranceDirector: "QualityAssuranceDirector",
  qualityAssuranceManager: "QualityAssuranceManager",
  inspectorAssignedSpecificCodes: "InspectorAssignedSpecificCodes",
  reviewerActions: "ReviewerActions",
  fieldQualityAssuranceAgent: "FieldQualityAssuranceAgent",
  appraisalQualityAssuranceAgent: "AppraisalQualityAssuranceAgent",
  valuationCoordinators: "ValuationCoordinators",
  valuationDirectorsInternetUser: "ValuationDirectorsInternetUser",
  valuationDirectorsEmployeeId: "ValuationDirectorsEmployeeId",
  customerType: "CustomerType",
  county: "County",
  exportType: "ExportType",
  fieldDevelopmentManager: "FieldDevelopmentManager",
  lenderLogisticsManager: "LenderLogisticsManager",
  appraisalPortStatus: "AppraisalPortStatus",
  rangeZeroToOneHundred: "RangeZeroToOneHundred",
  rangeZeroToTwoHundred: "RangeZeroToTwoHundred",
  zipCode: "ZipCode",
  surveyRating: "SurveyRating",
  feedbackCategory: "FeedbackCategory",
  appraiserManagers: "AppraiserManagers",
  activeInactive: "ActiveInactive",
  testAndTrainingAccounts: "TestAndTrainingAccounts",
  serviceRegion: "ServiceRegion",
  fieldOperationsManager: "FieldOperationsManager",
  feedbackResults: "FeedbackResults",
  lowMediumHighTiers: "LowMediumHighTiers",
  stackCodes: "StackCodes",
  customerServicePersonName: "CustomerServicePersonName",
  cubiCasaStatus: "CubiCasaStatus",
  timeHours: "TimeHours",
  timeWeeks: "TimeWeeks",
  departments: "Department",
  customerExperienceManagers: "CustomerExperienceManagers",
  customerExperienceDirectors: "CustomerExperienceDirectors",
  fieldRepAssigned: "FieldRepAssigned",
  satisfactionWithSchedulingProcess: "SatisfactionWithSchedulingProcessScore",
  didInspectorArriveOnTimeScore: "DidInspectorArriveOnTimeScore",
  inspectorsProfessionalismAndCommunicationScore: "InspectorsProfessionalismAndCommunicationScore",
  overallSatisfactionScore: "OverallSatisfactionScore",
};
